import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { getOperatingHours } from 'redux/selectors/members'
import { OperatingHours } from 'types/member/member'
import { checkIsInOperatingHoursRange, processOperatingHoursToRanges } from './utils'

export const useOperatingHoursRanges = (initialDate?: Date) => {
  const operatingHours: OperatingHours[] | null = useSelector(getOperatingHours)

  const baseDate = useMemo(() => new Date(initialDate || Date.now()), [initialDate])

  const operatingHoursRanges = useMemo(
    () => processOperatingHoursToRanges(operatingHours, baseDate),
    [baseDate, operatingHours],
  )

  const isInOperatingHoursRange = useMemo(
    () => checkIsInOperatingHoursRange(operatingHoursRanges, baseDate),
    [baseDate, operatingHoursRanges],
  )

  return { operatingHoursRanges, isInOperatingHoursRange }
}
